import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import LandingScreen from './screens/LandingScreen';
import AvisoPrivacidadScreen from './screens/AvisoPrivacidadScreen';
import TerminosCondicionesScreen from './screens/TerminosCondicionesScreen';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Ruta raíz redirige a la Landing */}
          <Route path="/" element={<LandingScreen />} />
          <Route path="/landing" element={<LandingScreen />} />
          
          {/* Rutas legales */}
          <Route path="/privacidad" element={<AvisoPrivacidadScreen />} />
          <Route path="/terminos" element={<TerminosCondicionesScreen />} />

          {/* Redirección para cualquier otra ruta inválida */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
